import { Action, Dispatch } from "redux";
import axios from "../../../config/axiosInterceptor";
import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import * as action_types from "./constants";
import { getClientListingType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const getPotentialDealListing = (payload: getClientListingType) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.post(
        `${baseURL}getPotentialDealListing`,
        payload
      );
      dispatch({
        type: action_types.GET_DEALS_LISTING,
        data: { payload: data?.data, loading: false, count: data?.count },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_DEALS_LISTING,
        data: { loading: false },
      });
    }
  };
};

export const removePotentialDealData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_DEALS_LISTING,
      data: { payload: {}, loading: true },
    });
  };
};

export const getPotentialDealDetails = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(
        `${baseURL}getPotentialDealDetails/${id}`
      );
      dispatch({
        type: action_types.GET_DEALS_DETAIL,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_DEALS_DETAIL,
        data: { loading: false },
      });
    }
  };
};

export const removeDealDetailData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_DEALS_DETAIL,
      data: { payload: {}, loading: true },
    });
  };
};

export const getPotentialDealFormData = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    const { data } = await axios.get(
      `${baseURL}getPotentialDealFormData/${id}`
    );
    dispatch({
      type: action_types.GET_DEALS_FORM_DATA,
      data,
    });
  };
};

export const getProposalFormData = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    const { data } = await axios.get(`${baseURL}getProposalFormData/${id}`);
    dispatch({
      type: action_types.GET_ESTIMATE_FORM_DATA,
      data,
    });
  };
};

export const getProposalById = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getProposalById/${id}`);
      dispatch({
        type: action_types.GET_PROPOSAL_BY_ID,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_PROPOSAL_BY_ID,
        data: { loading: false },
      });
    }
  };
};

export const removeProposalById = (loader: boolean) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_PROPOSAL_BY_ID,
      data: { payload: null, loading: loader },
    });
  };
};

export const getProposalDetailById = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getProposalDetailById/${id}`);
      dispatch({
        type: action_types.GET_PROPOSAL_DETAIL_BY_ID,
        data,
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_PROPOSAL_DETAIL_BY_ID,
        data: null,
      });
    }
  };
};

export const getProposalDoc = (payload: { proposal_id: string }) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.post(`${baseURL}getProposalDoc`, payload);
      dispatch({
        type: action_types.GET_PROPOSAL_BUILDER,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_PROPOSAL_BUILDER,
        data: { payload: null, loading: false },
      });
    }
  };
};
